// extracted by mini-css-extract-plugin
export var arrow = "langSwitcher-module--arrow--aa247";
export var dropdown = "langSwitcher-module--dropdown--df2e0";
export var dropdown__strong = "langSwitcher-module--dropdown__strong--ff5c8";
export var langSwitcher = "langSwitcher-module--langSwitcher--c0302";
export var langSwitcher_active = "langSwitcher-module--langSwitcher_active--d4fce";